import { memo, useMemo, CSSProperties, HTMLAttributes } from 'react'
import { Slider as MuiSlider, SliderThumb, SxProps } from '@mui/material'
import { SliderProps } from './Slider.types'
import { sliderStyles as styles } from './Slider.style'

function Slider(props: SliderProps) {
  const { sx, slots, ...otherProps } = props

  const isRange = Array.isArray(props.value) && props.value.length >= 2

  const mergedSlots = useMemo(
    () => ({
      ...slots,
      ...(isRange ? { thumb: ThumbComponent } : {}),
    }),
    [isRange, slots],
  )

  return (
    <MuiSlider
      sx={[styles.slider, sx] as SxProps}
      valueLabelDisplay={'on'}
      slots={mergedSlots}
      {...otherProps}
    />
  )
}

function ThumbComponent(props: HTMLAttributes<HTMLSpanElement>) {
  const { style, ...other } = props

  const leftPercent = parseFloat(String(style?.left ?? '0'))

  const updatedStyle: CSSProperties = useMemo(
    () => ({
      ...style,
      transform: `translate(-${leftPercent}%, -50%)`,
    }),
    [leftPercent, style],
  )

  return <SliderThumb style={updatedStyle} {...other} />
}

export default memo(Slider)
